import { create } from "zustand";

const CONFETTI_DURATION = 3000;

interface ConfettiState {
  active: boolean;
  fire: () => void;
}

export const useConfettiStore = create<ConfettiState>(set => ({
  active: false,
  fire: () => {
    set({ active: true });
    setTimeout(() => set({ active: false }), CONFETTI_DURATION);
  },
}));
